import React from 'react';
import classnames from 'classnames';
import EmptyBackground from '../EmptyBackground';
import BackgroundImage from '../../BackgroundImage';
import { useDeviationViewContext } from '../../../Context/DeviationViewContext';
import { getCoverImageFile } from '../../../DeviationViews/Thumb/helpers';
import s from './Journal.scss';
const JournalStageBackground = ({ deviation, width, height })=>{
    const { isFullscreen } = useDeviationViewContext();
    const preview = getCoverImageFile({
        deviation,
        width,
        height,
        allowHuge: true
    });
    return preview ? /*#__PURE__*/ React.createElement(BackgroundImage, {
        src: preview.src,
        className: classnames(!isFullscreen && s['background']),
        imageClassName: s['background-image'],
        fade: "full"
    }) : /*#__PURE__*/ React.createElement(EmptyBackground, {
        className: classnames(!isFullscreen && s['background'])
    });
};
JournalStageBackground.displayName = 'JournalStageBackground';
export default JournalStageBackground;
